import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  ListItem,
  maskName,
  BetStatus,
  ListElemText,
  ListItemCell,
  ListItemCont,
  convertAmount,
  useTranslation,
  TranslationKeys,
  exchangeAmountByRate,
  parseNumberByPrecision,
} from '@pascal/pascal-core';

import { marketTypeToName } from '../../../../../helpers';

export const OtherBets = observer(({ data: bet }) => {
  const t = useTranslation();

  return (
    <ListItemCont forRemove={bet.isRoundFinish || bet.status === BetStatus.Lose}>
      <ListItem active={bet.winAmount}>
        <ListItemCell>
          <ListElemText>
            {maskName(bet?.userId < 0 ? Math.abs(bet?.userId) : bet.playerExternalId)}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {' '}
            {marketTypeToName(
              bet.marketType ||
                (bet?.betData?.length && bet?.betData[0]?.marketType) ||
                (bet?.additionalParams?.markets.length &&
                  bet?.additionalParams?.markets[0]?.marketType),
              t
            )}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText style={{ textTransform: 'lowercase' }}>
            {bet.freeBetId
              ? t(TranslationKeys.FreeBet)
              : convertAmount(parseNumberByPrecision(exchangeAmountByRate(bet).amount, 1, 2))}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet.status === BetStatus.Pending
              ? '- - - - - -'
              : convertAmount(parseNumberByPrecision(exchangeAmountByRate(bet).winAmount, 1, 2))}
          </ListElemText>
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
});
